import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Knak Case Study | Canny';
const Description =
  "Read about how Knak's customer success team uses Canny to streamline feedback processes.";
const Image = 'https://canny.io/images/26e1cdee70dc5f876a06ce1339eec4b5.jpg';
const KnakUrl = 'https://canny.io/case-studies/knak';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${KnakUrl}#webpage`,
    url: KnakUrl,
    name: 'Case Study: Knak × Canny',
    description: "How Knak's customer success team uses Canny to streamline feedback processes.",
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${KnakUrl}#article`,
    genre: 'Case Study',
    headline: "How Knak's customer success team uses Canny to streamline feedback processes",
    description:
      "Knak's CSM team replaced fragmented feedback tools like Google Sheets and Salesforce with Canny as a single source of truth. Within Canny, teams track feedback, discuss internally, update statuses, and use the Changelog for clear notifications—saving time and improving transparency company-wide.",
    inLanguage: 'en',
    url: KnakUrl,
    mainEntityOfPage: { '@id': `${KnakUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Knak', url: 'https://knak.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Knak', item: KnakUrl },
  ]),
]);

export default class KnakLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: KnakUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
